module.exports = __webpack_public_path__ + "static/k1-45e37b0a24ba59b82e095e254bf86dce.jpg";